/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ClockFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ClockFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ClockFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ClockFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZoapoL': alignSelf,'--mt-2-ZoapoL': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZoapoL': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZoapoL': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZoapoL': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZoapoL': opacity,'--w-10-ZoapoL': typeof width === 'number' ? `${width}px` : width,'--h-11-ZoapoL': typeof height === 'number' ? `${height}px` : height,'--f-12-ZoapoL': fill,'--a-7-ZoapoL': isAnimated ? animation : "none",'--sd-8-ZoapoL': isAnimated ? strokeDashoffset : 0,'--sd-9-ZoapoL': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ClockFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.5.75A.75.75 0 015.25 0h3a.75.75 0 010 1.5H7.5v.546a6.001 6.001 0 11-1.5 0V1.5h-.75A.75.75 0 014.5.75zM1.28 3.53l1-1a.75.75 0 00-1.06-1.06l-1 1a.75.75 0 101.06 1.06zm9.94-2.06a.75.75 0 011.06 0l1 1a.75.75 0 01-1.06 1.06l-1-1a.75.75 0 010-1.06zM4.875 5.5a.625.625 0 01.875.125l1.313 1.75H9.25a.625.625 0 110 1.25h-2.5a.625.625 0 01-.5-.25l-1.5-2a.625.625 0 01.125-.875z"
 style={{'--f-12-ZoapoL': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}